import API from '../../functions/api';

const ARTICLES_LIST_LOADED = 'articles/list/loaded';
const ARTICLES_LIST_REQUESTED = 'articles/list/requested';

export function requestArticles(options) {
    return (dispatch) => {
        dispatch({
            type: ARTICLES_LIST_REQUESTED,
        });

        const { pageIndex, tag } = options;
        
        const pagesize = 12;
        
        let uri = '/articles';
        if (tag !== 'all') {
            uri = `/articles/tags/${tag}`
        }
        uri += `?pageSize=${pagesize}&$orderby=sortOrder asc&$count=true`;
        if (pageIndex > 0) {
            uri += `&$skip=${pageIndex * pagesize}`;
        }

        return API.get(uri)
        .then((res) => {
            dispatch({
                type: ARTICLES_LIST_LOADED,
                data: res.data,
                pageIndex: pageIndex + 1,
                tag: tag || 'all',
            });
        })
        .catch((error) => {
            console.log(`Couldn't get aricles:`, error);
        });
    };
}

const defaultContentState = {
    isFetching: false
};

export default function articlesList(state = defaultContentState, action) {
    switch (action.type) {
    case ARTICLES_LIST_REQUESTED:
        return Object.assign({}, state, {
            isFetching: true,
        });
    
    case ARTICLES_LIST_LOADED:

        const newArtices = state[action.tag] ? state[action.tag].articles.concat(action.data.items) : action.data.items;
        const areMore = action.data.nextPageLink == undefined ? false: true;

        return Object.assign({}, state, {
            [action.tag]: {
                articles: newArtices,
                pageIndex: action.pageIndex,
                canLoadMore: areMore,
            },
        });
    default:
        return state;
    }
}
